import React, { useEffect, useState, useCallback } from "react";
import {
  ReactMFE,
  Helpers,
  CommonMFE,
} from "@tpd-web-common-libs/nodejs-library";
import { Header } from "./App.style";
import UpperHeader from "./upper-header/UpperHeader";
import LowerHeaderDesktop from "./lower-header/desktop/LowerHeaderDesktop";
import LowerHeader from "./lower-header/LowerHeader";
import styled from "@emotion/styled";
import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import PuHeader from "./pu-header/PuHeader";
import contestoUtenteService from "./services/contesto-utente.service";
import ModalInfo from "./modal-info/ModalInfo";
import { Breadcrumbs } from "./breadcrumbs/Breadcrumbs";
import { Chatbot } from "@tpd-web-react-libs/nodejs-library/dist/src/components/Chatbot/Chatbot";

const retrieveCfFromStorage = async () => {
  const isUserLogged = Helpers.LoginHelper.userLogged;
  let inputData;
  if (isUserLogged) {
    return contestoUtenteService
      .recuperaContestoUtente()
      .then((val) => {
        if (val && val.tipo === "PF" && val.cf && val.cf.length === 16) {
          inputData.tipo = val.tipo;
          inputData.cf = val.cf;
        } else if (val && val.tipo === "PG") {
          inputData.tipo = val.tipo;
          inputData.cf = val.cf;
        }
        return inputData;
      })
      .catch(() => null);
  } else {
    return Helpers.SessionHelper.getData("dati_utente")
      .then(async (data) => {
        if (data && data.cf) {
          inputData.cf = data.cf;
          inputData.tipo = "PF";
          return inputData;
        }
      })
      .catch(() => null);
  }
};

const App = (props: ReactMFE.Types.TRemoteReactMFEProps) => {
  const {
    __host__,
    isEditMode,
    config: INITIAL_CONFIG,
    id: containerID,
  } = props;

  const [config, setConfig] = useState(INITIAL_CONFIG);
  const [tipo, setUserType] = useState<undefined | string>("");
  const [showModal, setShowModal] = useState(false);
  const [isPageSinistri, setIsPageSinistri] = useState(false);

  const showHideModal = () => {
    setShowModal(!showModal);
  };

  const retrieveCfData = useCallback(async () => {
    const UserData = await retrieveCfFromStorage();
    if (UserData && UserData.tipo) setUserType(UserData.tipo);
  }, []);

  let breadcrumbsStyleClassName = "margin-normal";
  if (
    __host__.pageProperties.isUtileASapersi &&
    __host__.pageProperties.isUtileASapersi === "true"
  ) {
    breadcrumbsStyleClassName = "margin-small";
  } else if (__host__.url.includes("notifiche")) {
    breadcrumbsStyleClassName = "margin-notifiche";
  } else if (
    __host__.url.includes("area_riservata") ||
    __host__.url.includes("accesso") ||
    __host__.url.includes("registrazione-cliente")
  ) {
    breadcrumbsStyleClassName = "margin-extra-small";
  }

  useEffect(() => {
    if (Helpers.PageHelper.isHCLAuthoringPage()) {
      Helpers.HeaderHelper.getHeaderConfig(
        __host__.url,
        __host__.pageTitle,
        __host__.pageProperties.displayBreadcrumbs
      )
        .then((newConfig) => {
          setConfig((oldConfig) => ({
            ...oldConfig,
            ...newConfig,
          }));
        })
        .catch((error) =>
          Helpers.ConsoleHelper.error(
            "Error in getHeaderConfig from header",
            error
          )
        );
    }

    retrieveCfData().catch((err) =>
      Helpers.ConsoleHelper.error("Error in retrieveCfData from header", err)
    );

    return () => {
      // do nothing
    };
  }, []);

  useEffect(() => {
    if(__host__.url.includes('area_riservata/sinistri')) {
      setIsPageSinistri(true);
    }
  });

  useEffect(() => {
    setConfig(INITIAL_CONFIG);
    return () => {
      // do nothing
    };
  }, [INITIAL_CONFIG]);

  return (
    <>
      {config && config.configHeader && config.configHeader.visible && (
        <>
          {__host__.profile &&
          __host__.profile.includes("unipolsai_prodotto_unico") ? (
            <PuHeader
              menuLivello1={config.menuLivello1}
              configHeader={config.configHeader}
              logoPath={config.logo}
            />
          ) : (
            <Header>
              {config.configHeader.menu_top && (
                <UpperHeader
                  id={CommonMFE.generateID(containerID, `UpperHeader`)}
                  __host__={__host__}
                  isEditMode={isEditMode}
                  corporateLinks={config.corporateLinks}
                />
              )}
              {Helpers.EnvironmentHelper.isClientSide() && isPageSinistri && <Chatbot></Chatbot>}
              <LowerHeaderDesktop
                id={CommonMFE.generateID(containerID, `LowerHeaderDesktop`)}
                __host__={__host__}
                isEditMode={isEditMode}
                navigationMenu={config.navigationMenu}
                menuLivello1={config.menuLivello1}
                configHeader={config.configHeader}
                logoPath={config.logo}
                tipo={tipo}
                showHideModal={showHideModal}
                config={config}
              />
              <LowerHeader
                id={CommonMFE.generateID(containerID, `LowerHeader`)}
                __host__={__host__}
                isEditMode={isEditMode}
                navigationMenu={config.navigationMenu}
                menuLivello1={config.menuLivello1}
                corporateLinks={config.corporateLinks}
                configHeader={config.configHeader}
                logoPath={config.logo}
                tipo={tipo}
                showHideModal={showHideModal}
                config={config}
              />
            </Header>
          )}
        </>
      )}
      {showModal && (
        // configuratore tpdCustomModal(Angular-widget)
        <ModalInfo
          id={containerID}
          __host__={__host__}
          showHideModal={showHideModal}
        />
      )}
      {config && config.breadcrumbs && (
        <Breadcrumbs
          className={breadcrumbsStyleClassName}
          breadcrumbs={config.breadcrumbs}
          isEditMode={isEditMode}
          id={CommonMFE.generateID(containerID, `breadcrumbs`)}
        />
      )}
    </>
  );
};

export default ReactMFE.PrimaryRemoteHOCFactory(
  React,
  styled,
  { CacheProvider },
  createCache
)(App);
